/* global axios */
import ApiClient from './ApiClient';

export const buildCompanyParams = (page, sort) => {
  let params = `page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

export const buildSearchParams = (query, page, sort) => {
  let params = `q=${encodeURIComponent(query)}&page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

class CompanyAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  get(params = {}) {
    const { page = 1, sort = 'name' } = params;
    const requestURL = `${this.url}?${buildCompanyParams(page, sort)}`;
    return axios.get(requestURL);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildSearchParams(query, page, sort)}`;
    return axios.get(requestURL);
  }

  // Buscar empresa por ID
  show(companyId) {
    return axios.get(`${this.url}/${companyId}`);
  }

  // Criar empresa
  create(companyData) {
    return axios.post(this.url, companyData);
  }

  // Atualizar empresa
  update(companyId, companyData) {
    return axios.patch(`${this.url}/${companyId}`, companyData);
  }

  // Excluir empresa
  delete(companyId) {
    return axios.delete(`${this.url}/${companyId}`);
  }

  // Buscar deals de uma empresa
  getDeals(companyId, params = {}) {
    return axios.get(`${this.url}/${companyId}/deals`, { params });
  }

  // Buscar contatos de uma empresa
  getContacts(companyId, params = {}) {
    return axios.get(`${this.url}/${companyId}/contacts`, { params });
  }

  // Buscar lista de industries
  getIndustries() {
    return axios.get(`${this.url}/industries`);
  }
}

export default new CompanyAPI();
